import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import {
  ASSESSMENT_AMENDMENT,
  ASSESSMENT_AMENDMENT_ALL,
  ASSESSMENT_AMENDMENT_ALL_UPDATED,
  ASSESSMENT_AMENDMENT_CREATE,
  ASSESSMENT_AMENDMENT_DELETE,
  ASSESSMENT_AMENDMENT_LIST,
  ASSESSMENT_AMENDMENT_PUBLISH,
  ASSESSMENT_MARKS_GENERATE,
  ASSESSMENT_MARK_STATUS,
  ASSESSMENT_ZIP_UPLOADS,
  GLOBAL_STATE,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { initialState } from './initialState'

export const ASSESSMENT_MARKS = GLOBAL_STATE

const assessmentMarksSlice = createSlice({
  name: ASSESSMENT_MARKS,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.assessmentAmendment.pending, state => {
        state[ASSESSMENT_AMENDMENT].loading = true
      })
      .addCase(actionCreators.assessmentAmendment.rejected, (state, action) => {
        state[ASSESSMENT_AMENDMENT].loading = false
        state[ASSESSMENT_AMENDMENT].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentAmendment.fulfilled, (state, action) => {
        state[ASSESSMENT_AMENDMENT].loading = false
        state[ASSESSMENT_AMENDMENT].error = null
        state[ASSESSMENT_AMENDMENT].data = action.payload
      })

    builder.addCase(actionCreators.assessmentAmendmentClear, state => {
      state[ASSESSMENT_AMENDMENT] = initialState().ASSESSMENT_AMENDMENT
    })

    builder
      .addCase(actionCreators.assessmentAmendmentCreate.pending, state => {
        state[ASSESSMENT_AMENDMENT_CREATE].loading = true
      })
      .addCase(actionCreators.assessmentAmendmentCreate.rejected, (state, action) => {
        state[ASSESSMENT_AMENDMENT_CREATE].loading = false
        state[ASSESSMENT_AMENDMENT_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentAmendmentCreate.fulfilled, (state, action) => {
        state[ASSESSMENT_AMENDMENT_CREATE].loading = false
        state[ASSESSMENT_AMENDMENT_CREATE].error = null
        state[ASSESSMENT_AMENDMENT_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.assessmentMarksGenerate.pending, state => {
        state[ASSESSMENT_MARKS_GENERATE].loading = true
      })
      .addCase(actionCreators.assessmentMarksGenerate.rejected, (state, action) => {
        state[ASSESSMENT_MARKS_GENERATE].loading = false
        state[ASSESSMENT_MARKS_GENERATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentMarksGenerate.fulfilled, (state, action) => {
        state[ASSESSMENT_MARKS_GENERATE].loading = false
        state[ASSESSMENT_MARKS_GENERATE].error = null
        state[ASSESSMENT_MARKS_GENERATE].data = action.payload
      })

    builder.addCase(actionCreators.assessmentMarksGenerateClear, state => {
      state[ASSESSMENT_MARKS_GENERATE] = initialState().ASSESSMENT_MARKS_GENERATE
    })

    builder
      .addCase(actionCreators.assessmentZipUploads.pending, state => {
        state[ASSESSMENT_ZIP_UPLOADS].loading = true
      })
      .addCase(actionCreators.assessmentZipUploads.rejected, (state, action) => {
        state[ASSESSMENT_ZIP_UPLOADS].loading = false
        state[ASSESSMENT_ZIP_UPLOADS].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentZipUploads.fulfilled, (state, action) => {
        state[ASSESSMENT_ZIP_UPLOADS].loading = false
        state[ASSESSMENT_ZIP_UPLOADS].error = null
        state[ASSESSMENT_ZIP_UPLOADS].data = action.payload
      })

    builder.addCase(actionCreators.assessmentZipUploadsClear, state => {
      state[ASSESSMENT_ZIP_UPLOADS] = initialState().ASSESSMENT_ZIP_UPLOADS
    })

    builder
      .addCase(actionCreators.assessmentAmendmentDelete.pending, state => {
        state[ASSESSMENT_AMENDMENT_DELETE].loading = true
      })
      .addCase(actionCreators.assessmentAmendmentDelete.rejected, (state, action) => {
        state[ASSESSMENT_AMENDMENT_DELETE].loading = false
        state[ASSESSMENT_AMENDMENT_DELETE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentAmendmentDelete.fulfilled, (state, action) => {
        state[ASSESSMENT_AMENDMENT_DELETE].loading = false
        state[ASSESSMENT_AMENDMENT_DELETE].error = null
        state[ASSESSMENT_AMENDMENT_DELETE].data = action.payload
      })

    builder
      .addCase(actionCreators.assessmentAmendmentList.pending, state => {
        state[ASSESSMENT_AMENDMENT_LIST].loading = true
      })
      .addCase(actionCreators.assessmentAmendmentList.rejected, (state, action) => {
        state[ASSESSMENT_AMENDMENT_LIST].loading = false
        state[ASSESSMENT_AMENDMENT_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentAmendmentList.fulfilled, (state, action) => {
        state[ASSESSMENT_AMENDMENT_LIST].loading = false
        state[ASSESSMENT_AMENDMENT_LIST].error = null
        state[ASSESSMENT_AMENDMENT_LIST].data = action.payload
      })

    builder.addCase(actionCreators.assessmentAmendmentListClear, state => {
      state[ASSESSMENT_AMENDMENT_LIST] = initialState().ASSESSMENT_AMENDMENT_LIST
    })

    builder
      .addCase(actionCreators.assessmentAmendmentAll.pending, state => {
        state[ASSESSMENT_AMENDMENT_ALL].loading = true
      })
      .addCase(actionCreators.assessmentAmendmentAll.rejected, (state, action) => {
        state[ASSESSMENT_AMENDMENT_ALL].loading = false
        state[ASSESSMENT_AMENDMENT_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentAmendmentAll.fulfilled, (state, action) => {
        state[ASSESSMENT_AMENDMENT_ALL].loading = false
        state[ASSESSMENT_AMENDMENT_ALL].error = null
        state[ASSESSMENT_AMENDMENT_ALL].data = action.payload
      })

    builder.addCase(actionCreators.assessmentAmendmentAllClear, state => {
      state[ASSESSMENT_AMENDMENT_ALL] = initialState().ASSESSMENT_AMENDMENT_ALL
    })

    builder
      .addCase(actionCreators.assessmentAmendmentAllUpdated.pending, state => {
        state[ASSESSMENT_AMENDMENT_ALL_UPDATED].loading = true
      })
      .addCase(actionCreators.assessmentAmendmentAllUpdated.rejected, (state, action) => {
        state[ASSESSMENT_AMENDMENT_ALL_UPDATED].loading = false
        state[ASSESSMENT_AMENDMENT_ALL_UPDATED].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentAmendmentAllUpdated.fulfilled, (state, action) => {
        state[ASSESSMENT_AMENDMENT_ALL_UPDATED].loading = false
        state[ASSESSMENT_AMENDMENT_ALL_UPDATED].error = null
        state[ASSESSMENT_AMENDMENT_ALL_UPDATED].data = action.payload
      })

    builder.addCase(actionCreators.assessmentAmendmentAllUpdatedClear, state => {
      state[ASSESSMENT_AMENDMENT_ALL_UPDATED] = initialState().ASSESSMENT_AMENDMENT_ALL_UPDATED
    })

    builder
      .addCase(actionCreators.assessmentAmendmentPublish.pending, state => {
        state[ASSESSMENT_AMENDMENT_PUBLISH].loading = true
      })
      .addCase(actionCreators.assessmentAmendmentPublish.rejected, (state, action) => {
        state[ASSESSMENT_AMENDMENT_PUBLISH].loading = false
        state[ASSESSMENT_AMENDMENT_PUBLISH].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentAmendmentPublish.fulfilled, (state, action) => {
        state[ASSESSMENT_AMENDMENT_PUBLISH].loading = false
        state[ASSESSMENT_AMENDMENT_PUBLISH].error = null
        state[ASSESSMENT_AMENDMENT_PUBLISH].data = action.payload
      })

    builder
      .addCase(actionCreators.assessmentMarkStatusChange.pending, state => {
        state[ASSESSMENT_MARK_STATUS].loading = true
      })
      .addCase(actionCreators.assessmentMarkStatusChange.rejected, (state, action) => {
        state[ASSESSMENT_MARK_STATUS].loading = false
        state[ASSESSMENT_MARK_STATUS].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentMarkStatusChange.fulfilled, (state, action) => {
        state[ASSESSMENT_MARK_STATUS].loading = false
        state[ASSESSMENT_MARK_STATUS].error = null
        state[ASSESSMENT_MARK_STATUS].data = action.payload
      })
  },
})

export const { reducer: assessmentMarksReducer } = assessmentMarksSlice
